import { render, staticRenderFns } from "./applications-list.vue?vue&type=template&id=725bbebc"
import script from "./applications-list.vue?vue&type=script&lang=js"
export * from "./applications-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports